import styled from 'styled-components';
import { FontSizes } from '../../../common/typography/typography.styles';

interface LabelProps {
  $bgColor: string;
  $order: number;
}

export const DeliveryOptionRibbonLabelContainer = styled.div`
  display: flex;
  position: absolute;
  top: -8px;
  left: -6px;
`;

export const DeliveryOptionRibbonLabel = styled.div<LabelProps>`
  font-size: ${FontSizes.small};
  font-weight: 600;
  color: #fff;
  line-height: 16px;
  padding: 2px 8px;
  border-radius: 4px 4px 4px 0;
  background-color: ${({ $bgColor }) => $bgColor};
  position: relative;
  transform: ${({ $order }) => `translateX(-${($order + 1) * 5}px)`};
  z-index: ${({ $order }) => 100 - $order};

  &:first-child {
    &:before {
      display: block;
      content: '';
      position: absolute;
      bottom: -5px;
      left: -0.2px;
      width: 11.3px;
      height: 5px;
      background-color: ${({ $bgColor }) => $bgColor};
      clip-path: polygon(0 0, 100% 0, 100% 100%, 0 0);
    }
  }
`;
